import { useEffect, useRef } from 'react';

type TimeoutProps = {
  /** Duration in seconds */
  duration: number;
  /** OnComplete */
  onComplete: () => void;
};

export default function Timeout({ duration, onComplete }: TimeoutProps): JSX.Element {
  const timerId = useRef<number | undefined>();
  useEffect(() => {
    if (timerId.current) {
      window.clearTimeout(timerId.current);
    }
    timerId.current = window.setTimeout(() => {
      onComplete();
    }, duration * 1000);

    return () => {
      if (timerId.current) {
        window.clearTimeout(timerId.current);
      }
    };
  }, [duration, onComplete]);
  return <></>;
}
